import { useEffect, useRef, useState } from "react";

export const useExitPresence = (value, duration) => {
  const lastRef = useRef(null);
  const [, setExpired] = useState(0);
  const present = value != null && value !== false;
  if (present) lastRef.current = value;
  const leaving = !present && lastRef.current != null;

  useEffect(() => {
    if (present || lastRef.current == null) return undefined;
    const timer = setTimeout(() => {
      lastRef.current = null;
      setExpired((count) => count + 1);
    }, duration);
    return () => clearTimeout(timer);
  }, [present, duration]);

  if (leaving) return { value: lastRef.current, leaving: true };
  return { value: present ? value : null, leaving: false };
};
